import { Grid, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom'
import { AppRoutes } from '../routes/route.path';
import { BackMobileIcon, NewInfoCircleIcon } from '../../icon';
import { appNote, ViewTextLabels } from '../shared/constants';
import Config from '../../config';
import { UserService } from '../../services/UserService';
interface props {
    IsMobileDevice: boolean;
    Title: string;
    subTitle?: string;
    count?: number;
    version?: boolean;
    ShowTooltip?: boolean;
    TooltipText?: string;
}

const SettingsHeader = (props: props) => {
    const navigate = useNavigate();

    return (
        <>
            <Grid item xs={12}>
                <div className={`${props.IsMobileDevice ? " d-flex color-header-title-font box-shadow-display-background-shadow bb-primary-divider-4 align-center" : "d-flex  h1-semibold color-settings-heading "}`}>
                    {!!props.IsMobileDevice && !UserService.hasSysAdminRole() && <span className={`d-flex`}>
                        <BackMobileIcon className={`c-pointer p-1 w-3 my-auto`}
                            onClick={() => navigate(AppRoutes.SETTINGS)} />
                    </span>
                    }
                    <div className="d-flex flex-direction w-p-100">
                        <div className=''>
                            {!UserService.hasSysAdminRole() &&
                                <span className={`${props.IsMobileDevice ? "h4-semibold color-header-title-font" : "h2-semibold color-settings-heading"} mr-auto my-auto `}>{props.Title} {!!props.count && props.count > 0 ? `(${props.count})` : ''}</span>
                            }
                            {!props.IsMobileDevice && props.ShowTooltip &&
                                <Tooltip title={props.TooltipText}>
                                    <NewInfoCircleIcon className={"c-pointer"} />
                                </Tooltip>
                            }
                        </div>
                        <div className="d-flex justify-between align-center" >
                            {!props.IsMobileDevice && (
                                <span className="h5-regular">
                                    {props.subTitle}
                                </span>
                            )}
                            {props.version && !props.IsMobileDevice &&
                                <div className="d-flex align-center" style={{ gap: "10px" }}>
                                    <div className={`${props.IsMobileDevice ? "h2" : "h4-semibold"} color-primary-light`}>
                                        {ViewTextLabels.VERSION}
                                    </div>
                                    <div className={`d-flex version-spacing ${props.IsMobileDevice ? "h2" : "h4-semibold"} color-primary-light`}>
                                        {Config.VERSION}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Grid>
            {!props.IsMobileDevice && <div><hr className="unsubscribe-hr opacity-1 mt-1 mb-2"></hr></div>}
        </>
    )
}
export default SettingsHeader;




